import styled from 'styled-components';
import { ButtonStyles } from './Button';

const ButtonStyledDiv = styled.div(ButtonStyles);

export default ButtonStyledDiv;
